import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export default function AdminLogin() {
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!apiKey.trim()) {
      toast.error("Please enter an API key");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API}/api/admin/dashboard`, {
        headers: { "X-Admin-Key": apiKey }
      });
      if (response.ok) {
        localStorage.setItem("admin-api-key", apiKey);
        toast.success("Connected!");
        navigate("/admin/dashboard");
      } else {
        toast.error("Invalid API key");
      }
    } catch (error) {
      toast.error("Connection failed");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>InstaMerch Admin</CardTitle>
          <CardDescription>Enter your admin API key to continue</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="password"
              placeholder="Admin API Key"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
            />
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Connecting..." : "Login"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
